// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fGkXw","paragraph":"styles_paragraph__gLoNc"};